import React, { useEffect, useMemo, useState } from "react";
import axios from "../../utils/axios";
import { parseJwt } from "../../utils";
import useAuth from "../../hooks/useAuth";
import { UserContext } from "./context";

export const UserState = ({ children, user }) => {
  const [partner, setPartner] = useState({});
  const id = parseJwt(user)?.sub;
  const { isPartner } = useAuth();

  useEffect(() => {
    const fetchPartner = async () => {
      if (!isPartner) {
        setPartner(null);
        return null;
      }
      const { data } = await axios.get(`/partner/user/${id}?user`);
      if (data) {
        setPartner(data);
      }
      return data;
    };
    fetchPartner();
  }, []);

  const value = useMemo(
    () => ({
      partner,
    }),
    // eslint-disable-next-line
    [partner]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
